(function() {
  function initHeader(element) {
    if (!element || element.dataset.jrbBound === 'true') return;
    element.dataset.jrbBound = 'true';

    const toggle = element.querySelector('[data-jrb-mobile-toggle]');
    const nav = element.querySelector('[data-jrb-mobile-nav]');

    if (toggle && nav) {
      toggle.addEventListener('click', function() {
        const isOpen = nav.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', String(isOpen));
      });
    }
  }

  let activeModal = null;
  let returnFocus = null;

  function setLoginPanel(modal, name) {
    modal.querySelectorAll('[data-jrb-login-tab]').forEach((button) => {
      const selected = button.dataset.jrbLoginTab === name;
      button.classList.toggle('is-active', selected);
      button.setAttribute('aria-selected', String(selected));
      button.tabIndex = selected ? 0 : -1;
    });
    modal.querySelectorAll('[data-jrb-login-panel]').forEach((panel) => {
      const selected = panel.dataset.jrbLoginPanel === name;
      panel.classList.toggle('is-active', selected);
      panel.hidden = !selected;
    });
  }

  function updateLoginLinks(root) {
    const current = new URL(window.location.href);
    // Only return to this storefront, never an external return_to or a legacy credential URL.
    const path = /\/account(?:\/|$)/.test(current.pathname) ? '/' : current.pathname + current.search + current.hash;
    root.querySelectorAll('[data-jrb-storefront-login]').forEach((link) => {
      link.href = '/customer_authentication/login?return_to=' + encodeURIComponent(path);
    });
  }

  function initLoginModal(modal) {
    if (!modal || modal.dataset.jrbBound === 'true') return;
    modal.dataset.jrbBound = 'true';
    modal.addEventListener('close', function() {
      document.body.classList.remove('jrb-modal-open');
      activeModal = null;
      if (returnFocus && returnFocus.isConnected) returnFocus.focus();
    });
    modal.addEventListener('keydown', function(event) {
      if (event.key === 'Tab') {
        const targets = Array.from(modal.querySelectorAll('a[href], button:not([disabled]), [tabindex="0"]'))
          .filter((element) => element.tabIndex >= 0 && element.getClientRects().length > 0);
        const first = targets[0];
        const last = targets[targets.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
        return;
      }
      const currentTab = event.target.closest('[data-jrb-login-tab]');
      if (!currentTab || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      const tabs = Array.from(modal.querySelectorAll('[data-jrb-login-tab]'));
      let index = tabs.indexOf(currentTab);
      if (event.key === 'Home') index = 0;
      else if (event.key === 'End') index = tabs.length - 1;
      else index = (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
      setLoginPanel(modal, tabs[index].dataset.jrbLoginTab);
      tabs[index].focus();
    });
  }

  // Delegation also covers headers replaced in the theme editor.
  document.addEventListener('click', function(event) {
    const trigger = event.target.closest('[data-jrb-login-open]');
    if (trigger && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey) {
      const modal = document.querySelector('[data-jrb-login-modal]');
      if (!modal || typeof modal.showModal !== 'function') return;
      event.preventDefault();
      initLoginModal(modal);
      returnFocus = trigger;
      const drawer = trigger.closest('.mobile-toggle-wrapper');
      if (drawer) {
        drawer.removeAttribute('open');
        drawer.classList.remove('active');
        document.body.classList.remove('overflow-hidden');
        returnFocus = drawer.querySelector('.mobile-toggle');
      }
      updateLoginLinks(modal);
      setLoginPanel(modal, trigger.dataset.jrbLoginTarget || 'create');
      activeModal = modal;
      document.body.classList.add('jrb-modal-open');
      modal.showModal();
      modal.querySelector('[aria-selected="true"]').focus();
      return;
    }
    const tab = event.target.closest('[data-jrb-login-tab]');
    if (tab && activeModal) setLoginPanel(activeModal, tab.dataset.jrbLoginTab);
    if (activeModal && event.target.closest('[data-jrb-login-close], [data-jrb-login-backdrop]')) activeModal.close();
    document.querySelectorAll('.jrb-account-menu[open]').forEach((menu) => {
      if (!menu.contains(event.target)) menu.removeAttribute('open');
    });
  });
  document.addEventListener('keydown', function(event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.jrb-account-menu[open]').forEach((menu) => {
      menu.removeAttribute('open');
      menu.querySelector('summary').focus();
    });
  });
  document.addEventListener('shopify:section:unload', function(event) {
    if (activeModal && event.target.contains(activeModal)) activeModal.close();
  });

  function formatDuration(ms) {
    const totalSeconds = Math.max(0, Math.floor(ms / 1000));
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    if (hours > 0) {
      return [hours, minutes, seconds].map((value) => String(value).padStart(2, '0')).join(':');
    }

    return [minutes, seconds].map((value) => String(value).padStart(2, '0')).join(':');
  }

  function initUrgencyBar(bar) {
    if (!bar || bar.dataset.jrbBound === 'true') return;
    bar.dataset.jrbBound = 'true';

    const countdown = bar.querySelector('[data-jrb-urgency-countdown]');
    const progress = bar.querySelector('[data-jrb-urgency-progress]');
    const current = Number(bar.dataset.currentCents || 0);
    const threshold = Number(bar.dataset.thresholdCents || 0);
    const endAt = bar.dataset.endsAt ? Date.parse(bar.dataset.endsAt) : NaN;

    if (progress && threshold > 0) {
      const ratio = Math.max(0, Math.min(100, (current / threshold) * 100));
      progress.style.width = ratio.toFixed(2) + '%';
    }

    if (countdown && !Number.isNaN(endAt)) {
      const updateCountdown = function() {
        const remaining = endAt - Date.now();
        countdown.textContent = remaining > 0 ? formatDuration(remaining) : countdown.dataset.expiredLabel || 'Expired';
      };

      updateCountdown();
      const interval = window.setInterval(function() {
        updateCountdown();
        if (endAt - Date.now() <= 0) {
          window.clearInterval(interval);
        }
      }, 1000);
    }
  }

  function initProductGrid(section) {
    if (!section || section.dataset.jrbBound === 'true') return;
    section.dataset.jrbBound = 'true';

    const tabs = Array.from(section.querySelectorAll('[data-jrb-grid-tab]'));
    const panels = Array.from(section.querySelectorAll('[data-jrb-grid-panel]'));
    if (!tabs.length || !panels.length) return;

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function activate(name) {
      tabs.forEach((tab) => {
        const isActive = tab.dataset.jrbGridTarget === name;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-current', isActive ? 'true' : 'false');
      });
    }

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', function() {
        const panel = panels.find((item) => item.dataset.jrbGridPanel === tab.dataset.jrbGridTarget);

        activate(tab.dataset.jrbGridTarget);

        if (panel) {
          panel.scrollIntoView({
            behavior: reducedMotion ? 'auto' : 'smooth',
            block: 'start'
          });
        }
      });

      tab.addEventListener('keydown', function(event) {
        if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
        event.preventDefault();
        const delta = event.key === 'ArrowRight' ? 1 : -1;
        const nextIndex = (index + delta + tabs.length) % tabs.length;
        tabs[nextIndex].focus();
      });
    });

    activate(tabs[0].dataset.jrbGridTarget);
  }

  function initAll(root) {
    updateLoginLinks(root);
    (root.querySelectorAll ? root.querySelectorAll('[data-jrb-header]') : []).forEach(initHeader);
    (root.querySelectorAll ? root.querySelectorAll('[data-jrb-login-modal]') : []).forEach(initLoginModal);
    (root.querySelectorAll ? root.querySelectorAll('[data-jrb-urgency]') : []).forEach(initUrgencyBar);
    (root.querySelectorAll ? root.querySelectorAll('[data-jrb-product-grid]') : []).forEach(initProductGrid);
  }

  document.addEventListener('DOMContentLoaded', function() {
    const legacyRedirect = document.querySelector('[data-jrb-account-redirect]');
    if (legacyRedirect) {
      window.location.replace(legacyRedirect.href);
      return;
    }
    initAll(document);
  });

  document.addEventListener('shopify:section:load', function(event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:select', function(event) {
    initAll(event.target);
  });
})();

(function() {
  function patchFreeEntriesAcceptSync() {
    const controller = window.jrbFreeEntriesOfferController;
    if (!controller || controller.__jrbAcceptCartSyncPatched || typeof controller.acceptOffer !== 'function' || typeof controller.syncCartState !== 'function') return false;

    const originalAcceptOffer = controller.acceptOffer;
    controller.acceptOffer = async function() {
      const cart = await this.syncCartState({ force: true });
      if (!cart || !Array.isArray(cart.items)) return;
      return originalAcceptOffer.apply(this, arguments);
    };
    controller.__jrbAcceptCartSyncPatched = true;
    return true;
  }

  function scheduleFreeEntriesAcceptSync() {
    patchFreeEntriesAcceptSync();
    window.setTimeout(patchFreeEntriesAcceptSync, 0);
    window.setTimeout(patchFreeEntriesAcceptSync, 75);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleFreeEntriesAcceptSync, { once: true });
  } else {
    scheduleFreeEntriesAcceptSync();
  }

  document.addEventListener('shopify:section:load', scheduleFreeEntriesAcceptSync);
})();

(function() {
  const CLAIMED_AT_PROPERTY = '_free_entries_claimed_at';

  function patchFreeEntriesController() {
    const controller = window.jrbFreeEntriesOfferController;
    if (!controller) return false;

    if (!controller.__jrbAcceptCartSyncPatched && typeof controller.acceptOffer === 'function' && typeof controller.syncCartState === 'function') {
      const originalAcceptOffer = controller.acceptOffer;
      controller.acceptOffer = async function() {
        const cart = await this.syncCartState({ force: true });
        if (!cart || !Array.isArray(cart.items)) return;
        return originalAcceptOffer.apply(this, arguments);
      };
      controller.__jrbAcceptCartSyncPatched = true;
    }

    if (!controller.__jrbSingleBonusLinePatched && typeof controller.ensureBonusLineItem === 'function' && typeof controller.fetchCart === 'function' && typeof controller.applyCartState === 'function') {
      controller.ensureBonusLineItem = function(countdownEnd) {
        if (this.__jrbBonusSyncRequest) {
          return this.__jrbBonusSyncRequest;
        }

        const syncRequest = (async () => {
          const properties = this.buildBonusProperties(countdownEnd);
          const countdownMinutes = Math.max(Number(this.config && this.config.countdownMinutes) || 0, 0);
          properties[CLAIMED_AT_PROPERTY] = new Date(countdownEnd - (countdownMinutes * 60 * 1000)).toISOString();
          let cart;
          let changed = false;

          try {
            cart = await this.fetchCart({ force: true });
          } catch (error) {
            return false;
          }

          if (!cart || !Array.isArray(cart.items)) {
            return false;
          }

          this.applyCartState(cart);

          if (!this.hasQualifyingCartItems(cart)) {
            return 'noop';
          }

          let configuredBonusLineItems = this.getConfiguredBonusLineItems(cart);

          if (configuredBonusLineItems.length > 1) {
            const removed = await this.removeBonusLineItems({
              lineItems: configuredBonusLineItems.slice(1),
              preserveExpiredState: true,
              preserveOfferState: true,
              silentRefresh: true
            });

            if (!removed) {
              return false;
            }

            changed = true;

            try {
              cart = await this.fetchCart({ force: true });
            } catch (error) {
              return false;
            }

            if (!cart || !Array.isArray(cart.items)) {
              return false;
            }

            this.applyCartState(cart);
            configuredBonusLineItems = this.getConfiguredBonusLineItems(cart);
          }

          let primaryLineItem = this.getBonusLineItems(cart)[0] || configuredBonusLineItems[0];

          if (!primaryLineItem) {
            const added = await this.addBonusLineItem(properties);
            if (!added) {
              return false;
            }
            changed = true;
          } else {
            const needsUpdate = primaryLineItem.quantity !== 1 || !this.areBonusPropertiesEqual(primaryLineItem.properties, properties);

            if (needsUpdate) {
              const lineItemUpdated = await this.changeLineItem(primaryLineItem.key, 1, properties);
              if (!lineItemUpdated) {
                return false;
              }
              changed = true;
            }
          }

          try {
            cart = await this.fetchCart({ force: true });
          } catch (error) {
            return false;
          }

          if (!cart || !Array.isArray(cart.items)) {
            return false;
          }

          this.applyCartState(cart);
          configuredBonusLineItems = this.getConfiguredBonusLineItems(cart);

          if (configuredBonusLineItems.length > 1) {
            const removed = await this.removeBonusLineItems({
              lineItems: configuredBonusLineItems.slice(1),
              preserveExpiredState: true,
              preserveOfferState: true,
              silentRefresh: true
            });

            if (!removed) {
              return false;
            }

            changed = true;

            try {
              cart = await this.fetchCart({ force: true });
            } catch (error) {
              return false;
            }

            if (!cart || !Array.isArray(cart.items)) {
              return false;
            }

            this.applyCartState(cart);
            configuredBonusLineItems = this.getConfiguredBonusLineItems(cart);
          }

          primaryLineItem = this.getBonusLineItems(cart)[0] || configuredBonusLineItems[0];

          if (!primaryLineItem || configuredBonusLineItems.length !== 1) {
            return false;
          }

          if (changed) {
            this.notifyCartRefresh();
            return 'mutated';
          }

          return 'noop';
        })();

        this.__jrbBonusSyncRequest = syncRequest.finally(() => {
          this.__jrbBonusSyncRequest = null;
        });

        return this.__jrbBonusSyncRequest;
      };

      controller.__jrbSingleBonusLinePatched = true;
    }

    return Boolean(controller.__jrbAcceptCartSyncPatched && controller.__jrbSingleBonusLinePatched);
  }

  function scheduleFreeEntriesPatches() {
    patchFreeEntriesController();
    window.setTimeout(patchFreeEntriesController, 0);
    window.setTimeout(patchFreeEntriesController, 75);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleFreeEntriesPatches, { once: true });
  } else {
    scheduleFreeEntriesPatches();
  }

  document.addEventListener('shopify:section:load', scheduleFreeEntriesPatches);
})();
